<template>
    <div class="min-h-screen bg-gray-100 flex items-center justify-center">
        <div class="max-w-md w-full bg-white rounded-lg shadow-md p-6">
            <h1 class="text-3xl font-bold text-center text-gray-800 mb-8">
                Sélection du Restaurant
            </h1>

            <div class="mb-6">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Sélectionnez votre profil serveur
                </label>
                <select
                        v-model="selectedServerId"
                        class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                    <option value="">Choisir un serveur</option>
                    <option
                            v-for="server in servers"
                            :key="server.id"
                            :value="server.id"
                    >
                        {{ server.name }}
                    </option>
                </select>
            </div>

            <div class="space-y-4">
                <div
                        v-for="restaurant in filteredRestaurants"
                        :key="restaurant.id"
                        class="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 cursor-pointer transition-colors"
                        @click="handleRestaurantSelection(restaurant)"
                >
                    <h3 class="text-xl font-semibold text-gray-800">{{ restaurant.name }}</h3>
                    <p class="text-gray-600">{{ restaurant.location }}</p>
                </div>
            </div>

            <div v-if="currentRestaurant && currentServer" class="mt-6 p-4 bg-green-50 rounded-lg">
                <p class="text-green-800">
                    Connecté en tant que <strong>{{ currentServer.name }}</strong>
                    à <strong>{{ currentRestaurant.name }}</strong>
                </p>
                <div class="mt-4 grid grid-cols-2 gap-4">
                    <router-link
                            to="/serveur/tables"
                            class="bg-blue-600 text-white py-2 px-4 rounded text-center hover:bg-blue-700 transition-colors"
                    >
                        Serveur
                    </router-link>
                    <router-link
                            to="/bardashboard"
                            class="bg-green-600 text-white py-2 px-4 rounded text-center hover:bg-green-700 transition-colors"
                    >
                        Bar
                    </router-link>
                    <router-link
                            to="/cuisinedashboard"
                            class="bg-yellow-600 text-white py-2 px-4 rounded text-center hover:bg-yellow-700 transition-colors"
                    >
                        Cuisine
                    </router-link>

                    <router-link
                            to="/caissedashboard"
                            class="bg-purple-600 text-white py-2 px-4 rounded text-center hover:bg-purple-700 transition-colors"
                    >
                        Caisse
                    </router-link>


                    <router-link
                            to="/adminrestaurants"
                            class="bg-purple-600 text-white py-2 px-4 rounded text-center hover:bg-purple-700 transition-colors"
                    >
                        adminrestaurants
                    </router-link>

                    <router-link
                            to="/gestion-commandes-en-ligne"
                            class="bg-purple-600 text-white py-2 px-4 rounded text-center hover:bg-purple-700 transition-colors"
                    >
                       TB commande-en-ligne
                    </router-link>

                    <router-link
                            to="/commande-en-ligne"
                            class="bg-purple-600 text-white py-2 px-4 rounded text-center hover:bg-purple-700 transition-colors"
                    >
                        commande-en-ligne
                    </router-link>
                </div>
            </div>

            <div v-if="selectedServerId && filteredRestaurants.length === 0" class="mt-4 p-4 bg-yellow-50 rounded-lg">
                <p class="text-yellow-800">
                    Aucun restaurant disponible pour ce serveur
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions, mapGetters } from 'vuex';

    export default {
        name: 'RestaurantSelector',
        data() {
            return {
                selectedServerId: ''
            };
        },
        computed: {
            ...mapState(['restaurants', 'servers', 'currentRestaurant', 'currentServer']),
            ...mapGetters(['currentCashRegister']),

            filteredRestaurants() {
                if (!this.selectedServerId) {
                    return this.restaurants;
                }

                const server = this.servers.find(s => s.id === parseInt(this.selectedServerId));
                if (!server) return this.restaurants;

                return this.restaurants.filter(restaurant => restaurant.id === server.restaurant_id);
            }
        },
        methods: {
            ...mapActions(['selectRestaurant', 'selectServer']),

            async handleRestaurantSelection(restaurant) {
                if (!this.selectedServerId) {
                    alert('Veuillez d\'abord sélectionner votre profil serveur');
                    return;
                }

                const server = this.servers.find(s => s.id === parseInt(this.selectedServerId));

                if (server && server.restaurant_id === restaurant.id) {
                    try {
                        // Sélectionner d'abord le serveur, puis le restaurant
                        await this.selectServer(server);
                        await this.selectRestaurant(restaurant); // Action Vuex, pas récursif !

                        console.log('Serveur sélectionné:', server.name);
                        console.log('Restaurant sélectionné:', restaurant.name);
                    } catch (error) {
                        console.error('Erreur lors de la sélection:', error);
                        alert('Erreur lors de la sélection');
                    }
                } else {
                    alert('Ce serveur n\'est pas affecté à ce restaurant');
                }
            }
        },
        watch: {
            selectedServerId(newVal) {
                if (newVal) {
                    const server = this.servers.find(s => s.id === parseInt(newVal));
                    if (server) {
                        this.selectServer(server);

                        // Sélectionner automatiquement le restaurant correspondant
                        const restaurant = this.restaurants.find(r => r.id === server.restaurant_id);
                        if (restaurant) {
                            this.handleRestaurantSelection(restaurant);
                        }
                    }
                } else {
                    // Réinitialiser la sélection si aucun serveur n'est choisi
                    this.selectServer(null);
                    this.selectRestaurant(null);
                }
            }
        },
        mounted() {
            console.log('Restaurants:', this.restaurants);
            console.log('Serveurs:', this.servers);
        }
    };
</script>